import dynamic from 'next/dynamic';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const Layout = dynamic(() => import('../../components/layoutComponent'));
const FaqComponent = dynamic(() => import('./faqComponent'));

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'faq'])),
    },
  };
}

export default function Faq() {
  return (
    <Layout>
      <FaqComponent />
    </Layout>
  );
}
